import { render, staticRenderFns } from "./styleContent.vue?vue&type=template&id=823e380e&scoped=true&"
import script from "./styleContent.ts?vue&type=script&lang=js&"
export * from "./styleContent.ts?vue&type=script&lang=js&"
import style0 from "./styleContent.less?vue&type=style&index=0&id=823e380e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823e380e",
  null
  
)

export default component.exports